import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {
  ITransaction, ITransactionCheck,
  ITransactionFilteredRequest, ITransactionsData,
} from './interface';
import {Observable, of, takeUntil} from 'rxjs';
import {environment} from '@env/environment';
import {getHttpParams} from '@shared/common-functions.util';
import {LocalStorageService} from '@services/local-storage.service';
import {AgGridService, IAgDataResponse} from '../../controls/ag-grid/utils';
import {map} from 'rxjs/operators';
import {TBankAccountSource} from '@common/types';

@Injectable({
  providedIn: 'root'
})
export class TransactionsService extends AgGridService<ITransactionFilteredRequest, ITransaction> {

  constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService,
  ) {
    super();
  }

  get(request: ITransactionFilteredRequest): Observable<IAgDataResponse<ITransaction>> {
    return this.http.get<ITransactionsData>(
      environment.API_URL + `/transactions/${request.source}/list`, getHttpParams(request)
    )
    .pipe(
      map((data) => ({
        rowData: data.transactions,
        rowCount: data.totalItems,
      }))
    );
  }

  delete(request: ITransactionFilteredRequest): Observable<boolean> {
    return this.http.delete<boolean>(environment.API_URL + '/transactions/delete', {
      body: request
    });
  }

  prepareFile(
    ext: 'qbo' | 'csv' | 'ofx' | 'pdf',
    request: ITransactionFilteredRequest,
    responseType: 'text' | 'blob',
    source: TBankAccountSource
  ): Observable<any> {
    return this.http.get(environment.API_URL + `/transactions/${source}/${ext}`, {
      responseType: responseType as 'json',
      ...getHttpParams(request),
    });
  }

  updateTransaction(data) {
    return this.http.put(environment.API_URL + `/transactions/${data.id}/update`, data);
  }

  updateRunningBalance(): Observable<boolean> {
    return this.http.put<boolean>(environment.API_URL + '/transactions/refresh', {
      username: this.localStorageService.getSelectedClientUsername(),
      dateRangeType: 'ONE_WEEK',
    });
  }

  updateRunningBalanceN(connectionId: number, source: TBankAccountSource): Observable<boolean> {
    return this.http.post<boolean>(environment.API_URL + `/transactions/${source}/refresh/bank-account/${connectionId}`, {});
  }

  askToClarify(data: {transactions: number[], sms: boolean, email: boolean, message: string}) {
    return this.http.post(environment.API_URL + '/transaction-clarification-request', data);
  }

  getCheck(checkImageId: number): Observable<ITransactionCheck> {
    return this.http.get<ITransactionCheck>(environment.API_URL + `/check-image/${checkImageId}`);
  }

  updateCheckOcr(data: Partial<ITransactionCheck>): Observable<ITransactionCheck> {
    return this.http.put<ITransactionCheck>(environment.API_URL + `/check-image/ocr/update`, data);
  }

  updateUserComment(transactionId: number, userComment: string): Observable<void> {
    // todo currently /transactions/${transactionId}/update does nothing
    return of(null);
    return this.http.put<void>(environment.API_URL + `/transactions/${transactionId}/update`, {
      id: transactionId,
      user_comment: userComment,
    });
  }
}
